import React, {useState, useEffect} from "react";
import {Form, Col, Input, Collapse, Card, Tag, Popover, Popconfirm, Modal, Row, notification} from 'antd';
import jsonfile from './journal.json'
import { Link, useHistory } from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import SmartDataTable from 'react-smart-data-table';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "util/IntlMessages";
import Config from "../../../../util/config";
import ActionButton2 from "../../../../util/ActionButton2";
import axios from "../../../../util/Api";
import {useForm} from "antd/es/form/Form";
import Loader from "../../../../components/Loader/Loader";

const Search = Input.Search;
const Panel = Collapse.Panel;

const JournalList = () => {
    const value = 0;
    const [state, setState] = useState({
        // reqURL: Config.apiserver+jsonfile.urls.list+"?isadjustable=1",
        reqURL: Config.apiserver + "accounts/journallist?isadjustable=1",
        filtervalue: '',
        subtitle: '',
    });
    const [form] = Form.useForm();
    const [thread, setThread] = useState(null);
    const [verifyModal, setVerifyModal] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        let url = Config.apiserver + "accounts/journallist?isadjustable=1";
        if (params.has("date")) {
            url = Config.apiserver + "accounts/journallist?isadjustable=1&date=" + params.get("date");
        }
        console.log(params);
        setState(
            {
                reqURL: url
            }
        );
    }, []);

    const history = useHistory();

    const content = (id) => {
        return (
            <div>
                {
                    CisUI().getPermission(jsonfile.urls.list, "edit") === 1 || CisUI().getUserInfo("com_id") === 0 ?
                        <p>
                            <Link to={jsonfile.urls.edit + `/${id}`}>
                                <button className="btn btn-primary btn-circle">
                                    <i className="fas fa-pencil-alt"/>
                                </button>
                                <IntlMessages id="Edit"/>
                            </Link>
                        </p> : ""}
                {
                    CisUI().getPermission(jsonfile.urls.list, "delete") === 1 || CisUI().getUserInfo("com_id") === 0 ?
                        <p>
                            <Link to="#" onClick={() => handleVoidVoucher(id)}>
                                {/*<Popconfirm title="Are you sure you want to void this?" onConfirm={() => handleVoidVoucher(id)}*/}
                                {/*            onCancel={handleVerifyCancel} okText="Yes"*/}
                                {/*            cancelText="No">*/}
                                    <button className="btn btn-danger btn-circle">
                                        <i className="fas fa-close"/>
                                    </button>
                                    <IntlMessages id="Void"/>
                                {/*</Popconfirm>*/}
                            </Link>
                        </p> : ""}
            </div>
        )
    };

    const headers = {
        // _id: {
        //     text: '#',
        //     invisible: false,
        //     filterable: false,
        //     transform: (value) => `${++value}`,
        // },
        id: {
            invisible : true
        },
        fund_program: {
            invisible : true
        },
        func_expense: {
            invisible : true
        },
        bank_account: {
            invisible : true
        },
        reference_no: { invisible : true },
        date: {
            text: <IntlMessages id="Date"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().DateFormat(value)
            )
        },
        entry_number: {
            text: <IntlMessages id="Entry Number"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                <Link to={"journaldetails/"+value}>{value}</Link>
            )
        },
        amount: {
            text: <IntlMessages id="Amount"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        status: {
            text: <IntlMessages id="Status"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => value === 3 ? <Tag style={{width : '100px'}} color="#7e1419">Voided</Tag> : <Tag style={{width : '100px'}} color="#34495e">Approved</Tag>
        },
        action: {
            text: <IntlMessages id="Action"/>,
            sortable: false,
            filterable: false,
            // transform: (value, idx, row) =>  ActionButton2(row.entry_number,jsonfile.urls,jsonfile.urls.list)
            // <a href={"/entries/journaledit/"+row.entry_number} className={"btn btn-primary btn-circle"}><i className="fas fa-edit" /></a>
            transform: (value, idx, row) =>

            {
                return (
                    <Popover placement="leftBottom" title={"Action"} content={() => content(row?.entry_number)} trigger="click">
                        <button className="btn btn-primary btn-circle"><i className="fas fa-ellipsis-h"></i></button>
                    </Popover>
                )
            }

        }
    };

    const orderedHeaders = jsonfile.listView.title;

    const getFields = () => {
        const count = expand ? 10 : 6;
        const children = [];
        const inputs = jsonfile.input;

        inputs.map((list, index) => {
            if(list.isFilterable == 1) {
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} key={index} style={{display: index < count ? 'block' : 'none'}}>
                        <div className="gx-form-row0">
                            <Form.Item
                                name={`${list.name}`}
                                label={`${list.label}`}
                                rules={[
                                    {
                                        required: true,
                                        message: "",
                                    },
                                ]}
                            >
                                <Input placeholder={list.name} />
                            </Form.Item>
                        </div>
                    </Col>,
                );
            }
        });
        return children;
    };

    const [expand, setExpand] = useState(false);

    const onFinish = values => {
        console.log('Received values of form: ', values);
        const qsup = CisUI().getQueryStrings(values);
        //reqURL = reqURL+"/?"+qsup;
        history.push("?"+qsup);
        const newURL = Config.apiserver+"accounts/journallist/?type=2&"+qsup;
        console.log(newURL)
        setState({reqURL: newURL});
    };

    const handleOnFilter = ({ target: { name, value } }) => {
        //filterValue = value;
        console.log("filteringwith :"+ value);
        setState({filtervalue : "test"});
    }

    let  searchView = "";
    if(jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']} >
                <Panel header="Advance Search"  key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.input,"",1,'date',CisUI().PeriodFiled(form))}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const getExtra = (
        <>
            {/*<Search*/}
            {/*    placeholder='Filter...'*/}
            {/*    name='filtervalue'*/}
            {/*    onSearch={handleOnFilter}*/}
            {/*    onChange={handleOnFilter}*/}
            {/*    style={{width: 200}}*/}
            {/*/>*/}
            {CisUI().listAction("../"+jsonfile.urls.add,"",state.reqURL,"data","journal_list",jsonfile,state.subtitle, "landscape")}
        </>
    );

    const JournalVoid = (hashdata) => {
        setLoader(true);

        axios.post(Config.apiserver + jsonfile.urls.void, hashdata)
            .then(res => {
                if (res.data.status === 1) {
                    notification.warning({
                        message: 'Alert',
                        type: "success",
                        description: res.data.msg
                    });
                } else {
                    notification.warning({
                        message: 'Alert',
                        type: "warning",
                        description: res.data.msg
                    });
                }
                setLoader(false);
            })
            .catch(errors => {
                console.log(errors);
                // document.getElementById("loader").style.display = "none";
            });
    }

    const handleVoidVoucher = (thread) => {
        setThread(thread);
        setVerifyModal(true);
    }

    const handleVerifyCancel = () => {
        setThread(null);
        setVerifyModal(false);
    }

    const voidJournalVerify = (values) => {
        if(thread !== null) {
            let data = {
                "userid": values['userid'],
                "password": values['password'],
                "thread": thread
            }
            axios
                .post(Config.apiserver + "accounts/journalvoidverify", data)
                .then((res) => {
                    if (res.data.status === 1) {
                        const newHashData = {
                            'token': res?.data?.token,
                            'thread': thread
                        };
                        setVerifyModal(false);
                        showConfirm(newHashData);
                        CisUI().showAlert("Success", "success", res.data.msg);
                    } else {
                        CisUI().showAlert("Error", "error", res.data.msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }


    const showConfirm = (hashData) => {
        console.log("showConfirm", hashData);
        Modal.confirm({
            title: 'Confirmation',
            content: 'Are you sure you want to void these journal?',
            okText: 'Ok',
            cancelText: 'Cancel',
            onOk() {
                JournalVoid(hashData);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    if(loader){
        return <Loader />;
    }

    return (
        <>

            {searchView}
            <Card title={jsonfile.listtitle} extra={getExtra}>
                <SmartDataTable
                    name='test-fake-table'
                    data={state.reqURL}
                    dataRequestOptions={CisUI().HeaderRequest}
                    dataKey="data"
                    headers={headers}
                    orderedHeaders={orderedHeaders}
                    hideUnordered={CisUI().hideUnordered}
                    className={CisUI().sematicUI.table}
                    filterValue={state.filterValue}
                    perPage={CisUI().perPage}
                    sortable
                    withLinks
                    withHeader
                    loader={CisUI().loader}
                    parseBool={{
                        yesWord: 'Yes',
                        noWord: 'No',
                    }}
                    parseImg={{
                        style: {
                            border: '1px solid #ddd',
                            borderRadius: '50px',
                            padding: '3px',
                            width: '30px',
                            height: '30px'
                        },
                    }}
                    emptyTable={CisUI().emptyTable}
                />
            </Card>

            <Modal title="Verify Your Identity" open={verifyModal}
                   okButtonProps={{form: 'verify', key: 'submit', htmlType: 'submit'}}
                   okText={"Submit"}
                // onOk={handleOk}
                   onCancel={handleVerifyCancel}
                // footer={null}
            >
                <Form
                    id="verify"
                    form={form}
                    {...CisUI().formItemLayout}
                    name="input"
                    // className="ant-advanced-search-form"
                    onFinish={voidJournalVerify}
                >
                    <Row gutter={24}>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    label="Username"
                                    name="userid"
                                    // onChange={handleChange}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Enter username"
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter username"/>
                                </Form.Item>
                            </div>
                        </Col>

                        <Col lg={24} md={24} sm={24} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="password"
                                    label="Password"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password/>
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>

                    {/*<Row>*/}
                    {/*    <div className="col-md-12" style={{textAlign: 'center', marginTop: '30px'}}>*/}
                    {/*        <Button type="primary" htmlType="submit">*/}
                    {/*            Submit*/}
                    {/*        </Button>*/}
                    {/*        <Button type="info" onClick={handleCancel}>Cancel</Button>*/}
                    {/*    </div>*/}
                    {/*</Row>*/}
                </Form>
            </Modal>
        </>
    );
};

export default JournalList;